import React from "react";
import { Modal } from "react-bootstrap";

export const IFrameModal = ({ show, handleClose }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      dialogClassName="modal-view-source"
      backdropClassName="modal-backdrop-view-source"
      aria-labelledby="example-custom-modal-styling-title"
    />
  );
};
